/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_Misa_Template_Without_CodeInputs */

const vi_invoice_misa_template_without_code = /** @type {(inputs: Invoice_Misa_Template_Without_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có mã cơ quan thuế`)
};

/**

* @param {Invoice_Misa_Template_Without_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const invoice_misa_template_without_code = /** @type {((inputs?: Invoice_Misa_Template_Without_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Misa_Template_Without_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_invoice_misa_template_without_code(inputs)
});